module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzQAAAABCAYAAAAILev0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGRJREFUeNpi/P//PwMuwMjIyAKkOICYB6juOcMgB/j8MhLAcPL/UPbLUHH7UHDnYHbjYHXbYHTXaFiNpvtRNw6fem64tbVGcttxKPhdSEjIDki9AeL3QPwFiH8A3f0HXR1AgAEAvbdB/3g+fnsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_document_middle.png
// module id = 684
// module chunks = 51